import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "offcanvas-footer" }

import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { approachesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useApproaches } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Approaches',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { approaches: allApproaches, isPending } = useApproaches();

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(approachesSchema),
  initialValues: { approaches: [] },
});

const approachesModel = useVeeField<number[]>("approaches");

onMounted(() => {
  resetForm({
    values: {
      approaches:
        session.value?.approaches.map((a: any) => a.approach_id) ?? [],
    },
  });
});

const approachOptions = computed(() =>
  allApproaches.value.map((a) => ({
    ...a,
    name: a.title,
    selected: approachesModel.$model.includes(a.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, approaches: values.approaches });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_CheckboxInput, {
        options: approachOptions.value,
        model: _unref(approachesModel)
      }, null, 8, ["options", "model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormButton, {
        marginVertical: false,
        label: "Concluir",
        loading: submitting.value,
        onOnClick: _unref(submit),
        disabled: !_unref(meta).valid
      }, null, 8, ["loading", "onOnClick", "disabled"])
    ])
  ], 64))
}
}

})